import React, {useState, useRef, useEffect} from 'react';
import AppHeader from '../components/AppHeader.js';
import post from '../utils/post.js';
import FormText from '../components/FormText.js';
import FormTextArea from '../components/FormTextArea.js';
import EditableProfilePhoto from '../components/EditableProfilePhoto.js';
import validateRestorePassword from '../utils/validateRestorePassword.js';
import '../styles/setting.scss';

const PRICE_FIELDS = [
	{key: 'ENTRY_PRICE_ONE', label: 'Jednorázový vstup'},
	{key: 'ENTRY_PRICE_WEEK1', label: 'Permanentka 1 týden'},
	{key: 'ENTRY_PRICE_WEEK2', label: 'Permanentka 2 týdny'},
	{key: 'ENTRY_PRICE_MONTH1', label: 'Permanentka 1 měsíc'},
	{key: 'ENTRY_PRICE_MONTH2', label: 'Permanentka 2 měsíce'},
	{key: 'ENTRY_PRICE_MONTH3', label: 'Permanentka 3 měsíce'},
	{key: 'PROMO_BONUS', label: 'Referenční bonus'}
];

export default function User({usrInfo, timerCnt, setUsrInfo}) {
	const [loading, setLoading] = useState(false);
	const [profilePhotoUrl, setProfilePhotoUrl] = useState('');
	const [phone, setPhone] = useState('');
	const [firstName, setFirstName] = useState('');
	const [firstNameError, setFirstNameError] = useState('');
	const [lastName, setLastName] = useState('');
	const [lastNameError, setLastNameError] = useState('');
	const [nickname, setNickname] = useState('');
	const [nicknameError, setNicknameError] = useState('');
	const [age, setAge] = useState('');
	const [ageError, setAgeError] = useState('');
	const [myweight, setMyweight] = useState('');
	const [myweightError, setMyweightError] = useState('');
	const [password, setPassword] = useState('');
	const [passwordError, setPasswordError] = useState('');
	const [password2, setPassword2] = useState('');
	const [passwordError2, setPasswordError2] = useState('');
	const [instructorNote, setInstructorNote] = useState('');
	const [instructorNoteError, setInstructorNoteError] = useState('');
	const [account, setAccount] = useState('');
	const [accountError, setAccountError] = useState('');
	const [accountPrice, setAccountPrice] = useState('');
	const [accountPriceError, setAccountPriceError] = useState('');
	const [accountPricePerm, setAccountPricePerm] = useState('');
	const [accountPricePermError, setAccountPricePermError] = useState('');
	const [nukiSmartLockId, setNukiSmartLockId] = useState('');
	const [notMemberNote, setNotMemberNote] = useState('');
	const [entryPersonMax, setEntryPersonMax] = useState('');
	const [entryAddPersonLock, setEntryAddPersonLock] = useState('');
	const [entryLessonMax, setEntryLessonMax] = useState('');
	const [tempSensors, setTempSensors] = useState([]);
	const [prices, setPrices] = useState({});
	const [result, setResult] = useState('');

	const firstNameRef = useRef();
	const lastNameRef = useRef();
	const nicknameRef = useRef();
	const ageRef = useRef();
	const myweightRef = useRef();
	const passwordRef = useRef();
	const passwordRef2 = useRef();
	const instructorNoteRef = useRef();
	const accountRef2 = useRef();
	const accountPriceRef = useRef();
	const accountPricePermRef = useRef();
	const nukiSmartLockIdRef = useRef();


	useEffect(() => {
		getData();
	}, []);

	const getData = () => {
		setLoading(true);

		post('getSetting', {})
			.then((res) => {
				const data = res.data || {};

				setProfilePhotoUrl(data.PROFILE_PHOTO_URL || '');
				setPhone(data.PHONES || '');
				setFirstName(data.FIRSTNAME || '');
				setLastName(data.LASTNAME || '');
				setNickname(data.NICKNAME || '');
				setAge(data.AGE || '');
				setMyweight(data.WEIGHT || '');
				setInstructorNote(data.INSTRUCTOR_NOTE || '');
				setAccount(data.INSTRUCTOR_ACCOUNT || '');
				setAccountPrice(data.INSTRUCTOR_PRICE || '');
				setAccountPricePerm(data.INSTRUCTOR_PRICE_PERM || '');
				setNukiSmartLockId(data.NUKI_SMART_LOCK_ID || '');
				setNotMemberNote(data.NOTMEMBER_NOTE || '');
				setEntryPersonMax(typeof data.ENTRY_PERSON_MAX === 'undefined' ? '' : String(data.ENTRY_PERSON_MAX));
				setEntryAddPersonLock(typeof data.ENTRY_ADDPERSON_LOCK === 'undefined' ? '' : String(data.ENTRY_ADDPERSON_LOCK));
				setEntryLessonMax(typeof data.ENTRY_LESSON_MAX === 'undefined' ? '' : String(data.ENTRY_LESSON_MAX));
				setTempSensors(Array.isArray(data.TEMP_SENSORS) ? data.TEMP_SENSORS : []);

				if (data.PRICELIST) {
					const loadedPrices = {};

					PRICE_FIELDS.forEach(({key}) => {
						const value = data.PRICELIST[key];
						const numericValue = Number(value);
						loadedPrices[key] = value === null || typeof value === 'undefined' || Number.isNaN(numericValue) ? '' : numericValue.toFixed(2);
					});

					setPrices(loadedPrices);
				}

				setLoading(false);
			})
			.catch((error) => {
				console.error(error);
				setLoading(false);
			});
	};

	const handleSubmit = (e) => {
		e.preventDefault();

		setFirstNameError('');
		setLastNameError('');
		setNicknameError('');
		setAgeError('');
		setMyweightError('');
		setPasswordError('');
		setPasswordError2('');
		setInstructorNoteError('');
		setAccountError('');
		setAccountPriceError('');
		setAccountPricePermError('');
		setResult('');

		let localError = 0;

		if (!firstName) {
			if (localError === 0) {
				firstNameRef.current.focus();
			}
			localError = 1;
			setFirstNameError('povinné');
		}

		if (!lastName) {
			if (localError === 0) {
				lastNameRef.current.focus();
			}
			localError = 1;
			setLastNameError('povinné');
		}

		if (password !== '') {
			const sError = validateRestorePassword(password, password2);
			setPasswordError(sError.password);
			setPasswordError2(sError.password2);

			if (sError.password !== '') {
				if (localError === 0) {
					passwordRef.current.focus();
				}
				localError = 1;
			}

			if (sError.password2 !== '') {
				if (localError === 0) {
					passwordRef2.current.focus();
				}
				localError = 1;
			}
		}

		if (localError === 0) {
			setLoading(true);

			const payload = {firstName, lastName, nickname, age, myweight, password, password2, instructorNote, account, accountPrice, accountPricePerm};

			if (usrInfo.sysAdmin === 1) {
				payload.nukiSmartLockId = nukiSmartLockId;
				payload.notMemberNote = notMemberNote;
				payload.entryPersonMax = entryPersonMax;
				payload.entryAddPersonLock = entryAddPersonLock;
				payload.entryLessonMax = entryLessonMax;
				payload.tempSensorDeltas = JSON.stringify(tempSensors.map((sensor) => ({id: sensor.ID, delta: sensor.DELTA})));
				payload.pricelist = JSON.stringify(prices);
			}

			post('saveSetting', payload)
				.then((res) => {
					setLoading(false);
					setPassword('');
					setPassword2('');
					setResult('Nastavení bylo uloženo.');

					// Propíšeme čerstvé usrInfo (vč. nových cen) do App stavu,
					// aby se ceny projevily všude bez reloadu stránky.
					if (typeof setUsrInfo === 'function' && res && res.usrInfo) {
						setUsrInfo(res.usrInfo);
					}
				})
				.catch((error) => {
					console.error(error);
					setLoading(false);
				});
		}
	};

	const handleAccountBlur = () => {
		setAccount((prevAccount) => prevAccount.replace(/\s+/g, ''));
	};

	const setTempSensorDelta = (sensorId, delta) => {
		setTempSensors((prevSensors) => prevSensors.map((sensor) => (sensor.ID === sensorId ? {...sensor, DELTA: delta} : sensor)));
	};

	const setPrice = (key, value) => {
		setPrices((prevPrices) => ({...prevPrices, [key]: value}));
	};

	const displayName = `${firstName} ${lastName}`.trim() || nickname || usrInfo.email || 'Uživatel';

	return (
		<>
			<div className="page_main">
				<AppHeader usrInfo={usrInfo} timerCnt={timerCnt} loading={loading} />

				<div className={`page setting-page ${usrInfo.sysAdmin === 1 || usrInfo.manager === 1 || usrInfo.instructor === 1 ? ' more' : ''}`}>
					<form method="POST" onSubmit={handleSubmit} className="setting-page__form">
						<section className="setting-page__hero">
							<div className="setting-page__profile-photo">
								<EditableProfilePhoto
									photoUrl={profilePhotoUrl}
									displayName={displayName}
									canEditPhoto
									uploadUrl="/rest/uploadProfilePhoto"
									deleteUrl="/rest/deleteProfilePhoto"
									entityKey={usrInfo.usrId}
									onPhotoChange={(nextPhotoUrl) => setProfilePhotoUrl(nextPhotoUrl)}
									avatarWidth="6rem"
									avatarHeight="6rem"
								/>
							</div>
							<div className="setting-page__profile-copy">
								<div className="setting-page__profile-name">{displayName}</div>
								{phone !== '' ? <div className="setting-page__profile-phone">{phone}</div> : ''}
								<div className="setting-page__profile-subtitle">{usrInfo.email}</div>
							</div>
						</section>

						<section className="setting-page__panel">
							<div className="setting-page__panel-head">
								<div className="setting-page__panel-title">Osobní údaje</div>
							</div>
							<div className="setting-page__fields">
								<div className="setting-page__field setting-page__field--half">
									<FormText type="text" label="Jméno" value={firstName} setValue={setFirstName} ref={firstNameRef} error={firstNameError} />
								</div>
								<div className="setting-page__field setting-page__field--half">
									<FormText type="text" label="Příjmení" value={lastName} setValue={setLastName} ref={lastNameRef} error={lastNameError} />
								</div>
								<div className="setting-page__field setting-page__field--full">
									<FormText type="text" label="Přezdívka" value={nickname} setValue={setNickname} ref={nicknameRef} error={nicknameError} />
								</div>
								<div className="setting-page__field setting-page__field--half">
									<FormText type="number" label="Věk" value={age} setValue={setAge} ref={ageRef} error={ageError} />
								</div>
								<div className="setting-page__field setting-page__field--half">
									<FormText type="number" label="Hmotnost" value={myweight} setValue={setMyweight} ref={myweightRef} error={myweightError} />
								</div>
							</div>
						</section>

						<section className="setting-page__panel">
							<div className="setting-page__panel-head">
								<div className="setting-page__panel-title">Zabezpečení</div>
								<div className="setting-page__panel-caption">Nové heslo se uloží jen pokud vyplníš obě pole a projdou validací.</div>
							</div>
							<div className="setting-page__fields">
								<div className="setting-page__field setting-page__field--half">
									<FormText type="password" label="Heslo" value={password} setValue={setPassword} ref={passwordRef} error={passwordError} />
								</div>
								<div className="setting-page__field setting-page__field--half">
									<FormText type="password" label="Znovu hesla" value={password2} setValue={setPassword2} ref={passwordRef2} error={passwordError2} />
								</div>
							</div>
						</section>

						{usrInfo.instructor === 1 ? (
							<section className="setting-page__panel setting-page__panel--accent">
								<div className="setting-page__panel-head">
									<div className="setting-page__panel-title">Instruktorské nastavení</div>
								</div>
								<div className="setting-page__fields">
									<div className="setting-page__field setting-page__field--full setting-page__field--iban">
										<FormText type="text" label="IBAN instruktora" value={account} setValue={setAccount} ref={accountRef2} error={accountError} onBlur={handleAccountBlur} />
										<div className="setting-page__note-text">Je nutné zadat IBAN kvůli správnému vygenerování QR kódu pro platbu.</div>
									</div>
									<div className="setting-page__field setting-page__field--half setting-page__field--account-price">
										<FormText type="number" label="Cena lekce" value={accountPrice} setValue={setAccountPrice} ref={accountPriceRef} error={accountPriceError} />
									</div>
									<div className="setting-page__field setting-page__field--half setting-page__field--account-price-perm">
										<FormText type="number" label="Cena lekce klienta s permicí" value={accountPricePerm} setValue={setAccountPricePerm} ref={accountPricePermRef} error={accountPricePermError} />
									</div>
									<div className="setting-page__field setting-page__field--full">
										<FormTextArea type="text" label="Poznámka k lekcím" height="15.6rem" value={instructorNote} setValue={setInstructorNote} ref={instructorNoteRef} error={instructorNoteError} />
									</div>
								</div>
							</section>
						) : ''}

						{usrInfo.sysAdmin === 1 ? (
							<>
								<section className="setting-page__panel setting-page__panel--danger">
									<div className="setting-page__panel-head">
										<div className="setting-page__panel-title">Ceník</div>
										<div className="setting-page__panel-caption">Systémové nastavení dostupné pouze pro sysadmina.</div>
									</div>
									<div className="setting-page__fields">
										{PRICE_FIELDS.map(({key, label}) => (
											<div className="setting-page__field setting-page__field--half" key={key}>
												<FormText type="number" label={label} value={prices[key] ?? ''} setValue={(value) => setPrice(key, value)} error="" />
											</div>
										))}
									</div>
								</section>

								{tempSensors.length > 0 ? (
									<section className="setting-page__panel setting-page__panel--danger">
										<div className="setting-page__panel-head">
											<div className="setting-page__panel-title">Teplotní čidla</div>
											<div className="setting-page__panel-caption">Korekce (delta) naměřené teploty jednotlivých čidel.</div>
										</div>
										<div className="setting-page__fields">
											{tempSensors.map((sensor) => (
												<div className="setting-page__field setting-page__field--half" key={sensor.ID}>
													<FormText type="text" label={sensor.NAME} value={sensor.DELTA ?? ''} setValue={(delta) => setTempSensorDelta(sensor.ID, delta)} error="" />
												</div>
											))}
										</div>
									</section>
								) : ''}

								<section className="setting-page__panel setting-page__panel--danger">
									<div className="setting-page__panel-head">
										<div className="setting-page__panel-title">Ostatní nastavení</div>
										<div className="setting-page__panel-caption">Limity rezervací a přístupový zámek. Změna se projeví ihned.</div>
									</div>
									<div className="setting-page__fields">
										<div className="setting-page__field setting-page__field--half">
											<FormText type="number" label="Max. počet rezervací v čase" value={entryPersonMax} setValue={setEntryPersonMax} error="" />
										</div>
										<div className="setting-page__field setting-page__field--half">
											<FormText type="number" label="Max. počet účastníků lekce" value={entryLessonMax} setValue={setEntryLessonMax} error="" />
										</div>
										<div className="setting-page__field setting-page__field--half">
											<FormText type="number" label="Uzamčení lekce od počtu osob" value={entryAddPersonLock} setValue={setEntryAddPersonLock} error="" />
										</div>
										<div className="setting-page__field setting-page__field--full">
											<FormText type="text" label="NUKI Smart Lock ID" value={nukiSmartLockId} setValue={setNukiSmartLockId} ref={nukiSmartLockIdRef} error="" />
										</div>
										<div className="setting-page__field setting-page__field--full">
											<FormTextArea type="text" label="Zpráva pro nečleny" height="15.6rem" value={notMemberNote} setValue={setNotMemberNote} error="" />
											<div className="setting-page__note-text">Zobrazí se na stránce výkonů uživatelům bez členství, kteří nemají pro dnešní den naplánovaný ani zadaný žádný výkon.</div>
										</div>
									</div>
								</section>
							</>
						) : ''}

						<div className="setting-page__actions">
							<input type="submit" name="button_save" value="Uložit" className="button green" disabled={loading} />
							{result !== '' ? <div className="setting-page__result" role="status">{result}</div> : ''}
						</div>
					</form>
				</div>
			</div>
		</>
	);
}
